import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { useEditTask } from "@planzone/view-models";
import { useModal } from "@root/client/modal";
import { TaskStatus as EditTaskStatus } from "@scenes/taskStatus";

import { Props } from "./types";
import styles from "./styles.scss";

function TaskStatus({ task, project }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const { editTask } = useEditTask(task);
  const isCompleted = task.percentComplete === 100;

  return (
    <div className={styles.taskStatus}>
      <EditTaskStatus
        status={task.status}
        project={project}
        isReduced
        canAddStatus
        isCompleted={isCompleted}
        selectStatus={(status) =>
          status.percentComplete === 100
            ? pushView({
                key: UseCases.markTaskAsCompleted,
                data: {
                  task,
                  project: project,
                },
              })
            : editTask({
                task,
                nextTask: {
                  ...task,
                  status,
                },
              })
        }
      />
    </div>
  );
}

export { TaskStatus };
